const ROUTE_TEMPLATE_ALLOWED_ROLES =
  new Set([
    "admin",
    "dispatcher",
  ]);

function parseStoredUser(rawValue) {
  if (!rawValue) {
    return null;
  }

  try {
    const parsed =
      JSON.parse(rawValue);

    return parsed &&
      typeof parsed === "object"
      ? parsed
      : null;
  } catch {
    return null;
  }
}

export function getStoredUser() {
  if (
    typeof window === "undefined"
  ) {
    return null;
  }

  const sessionUser =
    parseStoredUser(
      window.sessionStorage.getItem(
        "user"
      )
    );

  if (sessionUser) {
    return sessionUser;
  }

  return parseStoredUser(
    window.localStorage.getItem(
      "user"
    )
  );
}

export function getStoredUserRole() {
  return String(
    getStoredUser()?.role || ""
  )
    .trim()
    .toLowerCase();
}

export function canManageRouteTemplates() {
  return ROUTE_TEMPLATE_ALLOWED_ROLES.has(
    getStoredUserRole()
  );
}